<template>
  <div class="home-container">
    <!-- 轮播图 -->
    <BannerCarousel 
      :banners="banner"
      :interval="5000" 
      :arrow="'hover'" 
    />
    <!-- 关于我们 -->
    <section class="about-section">
      <div class="container">
        <div class="about-header">
          <div class="about-title">About·</div>
          <div class="about-subtitle">关于禄杰</div>
        </div>
        <div class="about-content">
          <div class="about-image">
            <img :src="aboutInfo.img" alt="">
          </div>
          <div class="about-text">
            <div class="right-title">{{ aboutInfo.title }}</div>
            <div class="right-content">{{ aboutInfo.content }}</div>
          </div>
        </div>
      </div>
    </section>
    <!-- 企业介绍 -->
    <section class="qiye-section">
      <div class="container">
        <div class="qiye-content">
          <div class="qiye-item">
            <div class="qiye-item1">始于</div>
            <div class="qiye-item2">2018</div>
            <div class="qiye-item3">{{ qyjj.title }}</div>
            <div class="qiye-item4">{{ qyjj.content }}</div>
          </div>
          <div class="qiye-image">
            <img :src="qyjj.img" alt="">
          </div>
        </div>
      </div>
    </section>
    <!-- 主要业务 -->
    <section class="services-section">
      <div class="services-bg">
        <div class="container">
          <div class="services-header">主要业务</div>
          <div class="services-grid">
            <div v-for="(item, index) in zyyw" :key="index" class="service-card">
              <div class="flex align-center justify-between">
                <div class="service-title">{{ item.title }}</div>
                <div class="service-number">0{{ index + 1 }}</div>
              </div>
              <div class="service-content">
                <div class="service-description">{{ item.content }}</div>
                <div class="service-image">
                  <img :src="item.img" :alt="item.title">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 业务介绍 -->
    <section class="ywjs-section">
      <div class="container">
        <div class="ywjs-content flex">
          <div class="ywjs-left flex-sub" style="margin-right: 30px;">
            <div class="left-content flex">
              <div class="flex-sub" style="margin-right: 30px;">
                <div class="ywjs-title">{{ fwjs1.title1 }}</div>
                <div class="ywjs-txt">{{ fwjs1.content1 }}</div>
              </div>
              <img :src="fwjs1.img1" alt="" class="left-image1">
            </div>
            <div class="left-content flex" style="margin-top: 20px;">
              <div class="flex-sub" style="margin-right: 30px;">
                <div class="ywjs-title">{{ fwjs1.title2 }}</div>
                <div class="ywjs-txt">{{ fwjs1.content2 }}</div>
              </div>
              <img :src="fwjs1.img2" alt="" class="left-image1">
            </div>
          </div>
          <div class="ywjs-right">
            <img :src="fwjs1.img3" alt="" class="left-image2">
          </div>
        </div>
      </div>
      <div class="container">
        <div class="ywjs-content flex">
          <div class="ywjs-right">
            <img :src="fwjs2.img3" alt="" class="left-image2">
          </div>
          <div class="ywjs-left flex-sub" style="margin-left: 30px;">
            <div class="left-content flex">
              <img :src="fwjs2.img1" alt="" class="left-image1"></img>
              <div class="flex-sub" style="margin-left: 30px;">
                <div class="ywjs-title">{{ fwjs2.title1 }}</div>
                <div class="ywjs-txt">{{ fwjs2.content1 }}</div>
              </div>
            </div>
            <div class="left-content flex" style="margin-top: 20px;">
              <img :src="fwjs2.img2" alt="" class="left-image1"></img>
              <div class="flex-sub" style="margin-left: 30px;">
                <div class="ywjs-title">{{ fwjs2.title2 }}</div>
                <div class="ywjs-txt">{{ fwjs2.content2 }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 合作伙伴 -->
    <section class="partner-section">
      <div class="container">
        <div class="partner-title">成功案例</div>
        <div class="partner-subtitle">
          航空运输服务可以根据客户的需求提供定制化的限时到达服务，国内一二线城市，8-10小时到达，三四线城市10-12小时到达，实现了能够迅速、高效地将货物运送到目的地。</div>
        <div class="partner-title" style="margin-top: 30px;">合作伙伴</div>
        <div class="partner-subtitle">
          公司与多家国内外知名企业建立了长期合作关系，如中微半导体，中科飞测，乐孜芯创，东方晶源微电子科技，飞微科技，楚赟精工科技和记黄埔医药，等，为这些企业提供全方位的供应链服务。这些
          合作关系进一步巩固了公司在行业内的领先地位‌。</div>
        <el-carousel height="157px" indicator-position="none" class="partner-carousel" :loop='true' arrow="always">
          <el-carousel-item v-for="(item, index) in hzhb" :key="index" class="partner-item">
            <img v-for="(ele, ide) in item" :key="ide" :src="ele.img" alt="" class="partner-img">
          </el-carousel-item>
        </el-carousel>
      </div>
    </section>
    <!-- 公司愿景 -->
    <section class="vision-section">
      <div class="container">
        <div class="vision-content flex  justify-center">
          <img :src="gsyj.img" alt="" class="vision-img">
          <div class="vision-text flex-sub">
            <div class="vision-title">公司愿景与未来发展</div>
            <div class="vision-subtitle"> 公司愿景</div>
            <div class="vision-txt">{{gsyj.vision}}</div>
            <div class="vision-subtitle"> 未来发展</div>
            <div class="vision-txt">{{gsyj.future}}</div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { getHomeData } from '@/api/home.js'
import BannerCarousel from '@/components/BannerCarousel.vue'
export default {
  name: 'Home',
  components: {
    BannerCarousel
  },
  data() {
    return {
      banner: [],//轮播图数据
      aboutInfo: {
        content: '',
        img: '',
        title: ''
      }, //关于我们数据
      qyjj: {
        content: '',
        img: '',
        title: ''
      }, //企业介绍数据
      zyyw: [], //主要业务数据
      fwjs1: {},//业务介绍数据
      fwjs2: {},//业务介绍数据
      hzhb: [],//合作伙伴数据
      gsyj: {
        future: '',
        img: '',
        vision: ''
      }, //公司愿景数据

    }
  },
  mounted() {
    this.getHomeData();
  },
  methods: {
    getHomeData() {
      getHomeData({}).then(res => {
        if (res.code == '1') {
          this.banner = res.data.lb;
          this.aboutInfo = res.data.qyjj[0];
          this.qyjj = res.data.qyjj[1];
          this.zyyw = res.data.zyyw;
          this.fwjs1 = res.data.fwjs[0];
          this.fwjs2 = res.data.fwjs[1];
          const list = res.data.hzhb;
          for (let i = 0, l = list.length; i < l; i += 5) {
            this.hzhb.push(list.slice(i, i + 5))
          }
          this.gsyj = res.data.gsyj;
        }
      })
    },
  }
}
</script>

<style scoped>
.home-container {
  width: 100%;
  background-color: #fff;
}



/* 通用容器样式 */
.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 关于我们样式 */
.about-title {
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  font-size: 74px;
  color: #333333;
}

.about-subtitle {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 36px;
  color: #333333;
}

.about-section {
  padding-top: 50px;
  background-color: #fff;
}

.about-content {
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

.about-text {
  flex: 1;
  min-width: 500x;
  background: #F8FAFB;
  padding: 40px 60px;
  margin-left: 100px;
}

.right-title {
  font-weight: 500;
  font-size: 22px;
  color: #333333;
}

.right-content {
  margin-top: 20px;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  line-height: 1.8;
}

.about-image {
  width: 338px;
  height: 514px;
}

.about-image img {
  width: 100%;
  height: auto;
}

/* 企业介绍样式 */
.qiye-section {
  padding-top: 50px;
  width: 100%;
  background-color: #fff;
}

.qiye-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

.qiye-item {
  flex: 1;
  min-width: 500x;
  margin-right: 100px;
}

.qiye-item1 {
  font-weight: 600;
  font-size: 22px;
  color: #777777;
}

.qiye-item2 {
  font-weight: 600;
  font-size: 52px;
  color: #5C95E0;
}

.qiye-item3 {
  font-weight: 500;
  font-size: 22px;
  color: #333333;
  margin-top: 50px;
}

.qiye-item4 {
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  line-height: 1.8;
  margin-top: 30px;
}

.qiye-image {
  width: 827px;
  height: 439px;
}

.qiye-image img {
  width: 100%;
  height: auto;
}



/* 主要业务样式 */
.services-bg {
  margin-top: 50px;
  width: 100%;
  background: url('@/assets/images/3.png') no-repeat center center;
  background-size: cover;
  padding: 50px 0;
  position: relative;
}

.services-header {
  text-align: center;
  font-weight: bold;
  font-size: 36px;
  color: #FFFFFF;
  margin-bottom: 40px;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
  gap: 40px;
}

.service-card {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 320px;
  padding: 50px;
}

.service-number {
  color: #BFBFBF;
  font-size: 24px;
  font-weight: 500;
}

.service-title {
  font-weight: bold;
  font-size: 24px;
  color: #333333;
}

.service-content {
  display: flex;
  justify-content: space-between;
  flex: 1;
  margin-top: 30px;
}

.service-description {
  flex: 1;
  font-size: 16px;
  color: #333;
  line-height: 1.8;
  margin-right: 100px;
  padding: 10px 0;
}

.service-image {
  width: 200px;
  height: 160px;
  overflow: hidden;
}

.service-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 业务介绍样式 */
.ywjs-section {
  width: 100%;
}

.ywjs-content {
  margin-top: 50px;
}

.ywjs-title {
  font-weight: 600;
  font-size: 24px;
  color: #333333;
}

.ywjs-txt {
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  line-height: 1.8;
  margin-top: 30px;
}

.left-image1 {
  width: 463px;
  height: 255px;
}

.left-image2 {
  width: 463px;
  height: 535px;
}

/* 业务介绍响应式设计 */
@media (max-width: 1200px) {
  .ywjs-content {
    flex-direction: column;
    align-items: center;
  }
  
  .ywjs-left {
    margin-right: 0 !important;
    margin-bottom: 30px;
  }
  
  .ywjs-left:nth-child(2) {
    flex-direction: column-reverse;
  }
  
  .left-image2 {
    width: 100%;
    height: auto;
    max-width: 463px;
  }
}

@media (max-width: 768px) {
  .left-content {
    flex-direction: column;
  }
  
  .left-content > div:nth-child(1) {
    margin-right: 0 !important;
    margin-bottom: 20px;
  }
  
  .left-content:nth-child(2) > div:nth-child(1) {
    margin-left: 0 !important;
    margin-bottom: 20px;
  }
  
  .left-image1 {
    width: 100%;
    height: auto;
    max-width: 463px;
  }
  
  .ywjs-title {
    font-size: 20px;
  }
}

/* 合作伙伴样式 */
.partner-section {
  margin-top: 50px;
  width: 100%;
  background: #F5F5F5;
  padding: 30px 0 50px;
}

.partner-title {
  font-weight: 600;
  font-size: 24px;
  color: #333333;
}

.partner-subtitle {
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  line-height: 1.8;
  margin-top: 24px;
}

.partner-carousel {
  margin-top: 50px;
}
/* 修改合作伙伴轮播图箭头 */
.partner-carousel >>> .el-carousel__arrow {
  background-color: #5C95E0;
  color: #ffffff;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 18px;
  top: 50%;
  transform: translateY(-50%);
}
.partner-carousel >>> .el-carousel__arrow:hover {
  background-color: #4a84d3;
  color: #ffffff;
}

.partner-item {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
}

.partner-img {
  width: 100%;
  height: 157px;
  object-fit: cover;
}

/* 合作伙伴响应式设计 */
@media (max-width: 1200px) {
  .partner-item {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 992px) {
  .partner-item {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .partner-item {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .partner-img {
    height: 120px;
  }
  
  .partner-title {
    font-size: 20px;
  }
}

@media (max-width: 480px) {
  .partner-item {
    grid-template-columns: 1fr;
  }
  
  .partner-img {
    height: 100px;
  }
}

/* 公司愿景样式 */
.vision-section {
  width: 100%;
  background: url('@/assets/images/4.png') no-repeat center center;
  background-size: cover;
  padding: 50px 0;
  position: relative;
}

.vision-content {
  padding: 0 100px;
}

.vision-img {
  width: 461px;
  height: 461px;
}

.vision-text {
  margin-left: 70px;
  color: #FFFFFF;
}

.vision-title {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: bold;
  font-size: 26px;
  color: #FFFFFF;
}

.vision-subtitle {
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  font-size: 24px;
  color: #FFFFFF;
  margin-top: 30px;
}
.vision-txt {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 1.8;
  margin-top: 30px;
}

/* 公司愿景响应式设计 */
@media (max-width: 1200px) {
  .vision-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 0 20px;
  }
  
  .vision-text {
    margin-left: 0;
    margin-top: 30px;
  }
  
  .vision-img {
    width: 100%;
    height: auto;
    max-width: 461px;
  }
}

@media (max-width: 768px) {
  .vision-title {
    font-size: 22px;
  }
  
  .vision-subtitle {
    font-size: 20px;
  }
  
  .vision-content {
    padding: 0 15px;
  }
}







/* 响应式设计 */
@media (max-width: 1200px) {
  .services-grid {
    grid-template-columns: 1fr;
    max-width: 800px;
  }
}

@media (max-width: 768px) {
  .services-header {
    font-size: 28px;
    margin-bottom: 40px;
  }

  .service-content {
    flex-direction: column;
  }

  .service-description {
    margin-right: 0;
    margin-bottom: 20px;
  }

  .service-image {
    width: 100%;
    height: 200px;
  }
}

/* 响应式设计 */
@media (max-width: 768px) {

  .about-content {
    flex-direction: column;
  }

  .about-text {
    margin-left: 0;
    margin-top: 30px;
  }

  .qiye-content {
    flex-direction: column;
  }

  .qiye-item {
    margin-right: 0;
    margin-bottom: 30px;
  }


  .contact-info {
    flex-direction: column;
    align-items: center;
  }
}
</style>